/* =============================================================
   STATS BAND — Key metrics that build credibility
   Addresses: Original site had no proof of scale or results
   Design: Full-width gold accent band with large numbers
   ============================================================= */

function Counter({ target, suffix = "", prefix = "" }: { target: number; suffix?: string; prefix?: string }) {
  return (
    <div>
      {prefix}{target}{suffix}
    </div>
  );
}

const stats = [
  { value: 150, suffix: "+", label: "Happy Clients", sub: "Across Perth & WA" },
  { value: 10, suffix: "+", label: "Years Experience", sub: "In Bookkeeping" },
  { value: 98, suffix: "%", label: "Client Retention", sub: "Year on Year" },
  { value: 24, suffix: "hr", label: "Response Time", sub: "Guaranteed" },
];

// Laurel wreath SVG component (Oscar-style)
function LaurelWreath() {
  const goldColor = "#b8a038"; // Gold color matching the stats band
  return (
    <>
      {/* Left laurel wreath */}
      <div className="absolute -left-6 top-1/2 -translate-y-1/2 w-12 h-24 pointer-events-none z-20">
        <svg className="w-full h-full" viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet">
          <g fill={goldColor}>
            <ellipse cx="20" cy="10" rx="3" ry="6" transform="rotate(-30 20 10)" />
            <ellipse cx="18" cy="15" rx="3" ry="6" transform="rotate(-20 18 15)" />
            <ellipse cx="17" cy="22" rx="3" ry="6" transform="rotate(-10 17 22)" />
            <ellipse cx="18" cy="30" rx="3" ry="6" transform="rotate(0 18 30)" />
            <ellipse cx="20" cy="38" rx="3" ry="6" transform="rotate(10 20 38)" />
            <ellipse cx="24" cy="44" rx="3" ry="6" transform="rotate(20 24 44)" />
            <ellipse cx="30" cy="48" rx="3" ry="6" transform="rotate(30 30 48)" />
          </g>
        </svg>
      </div>
      
      {/* Right laurel wreath */}
      <div className="absolute -right-6 top-1/2 -translate-y-1/2 w-12 h-24 pointer-events-none z-20">
        <svg className="w-full h-full" viewBox="0 0 60 60" preserveAspectRatio="xMidYMid meet">
          <g fill={goldColor}>
            <ellipse cx="40" cy="10" rx="3" ry="6" transform="rotate(30 40 10)" />
            <ellipse cx="42" cy="15" rx="3" ry="6" transform="rotate(20 42 15)" />
            <ellipse cx="43" cy="22" rx="3" ry="6" transform="rotate(10 43 22)" />
            <ellipse cx="42" cy="30" rx="3" ry="6" transform="rotate(0 42 30)" />
            <ellipse cx="40" cy="38" rx="3" ry="6" transform="rotate(-10 40 38)" />
            <ellipse cx="36" cy="44" rx="3" ry="6" transform="rotate(-20 36 44)" />
            <ellipse cx="30" cy="48" rx="3" ry="6" transform="rotate(-30 30 48)" />
          </g>
        </svg>
      </div>
    </>
  );
}

export default function StatsBand() {
  return (
    <section className="py-16 bg-[oklch(0.72_0.12_75)]">
      <div className="container">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-4">
          {stats.map((stat, index) => (
            <div
              key={stat.label}
              className={`text-center relative ${index < stats.length - 1 ? "lg:border-r lg:border-[oklch(0.15_0.04_250)/0.2]" : ""} ${index < 3 ? "px-4" : ""}`}
            >

              <div
                className="text-4xl lg:text-5xl font-bold text-[oklch(0.15_0.04_250)] mb-1 relative z-10"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                <Counter target={stat.value} suffix={stat.suffix} />
              </div>
              <div className="text-[oklch(0.15_0.04_250)] font-semibold text-base mb-0.5 relative z-10" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {stat.label}
              </div>
              <div className="text-[oklch(0.15_0.04_250)/0.6] text-xs relative z-10" style={{ fontFamily: "'DM Sans', sans-serif" }}>
                {stat.sub}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
